export default "<div [innerHtml]=\"termsText\"></div>\n"